var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.13848 2.46368C9.61225 0.512107 12.3877 0.512108 12.8615 2.46368C13.1676 3.72437 14.6119 4.32264 15.7198 3.64761C17.4348 2.60266 19.3973 4.56523 18.3524 6.28021C17.6774 7.38806 18.2756 8.83242 19.5363 9.13847C21.4879 9.61225 21.4879 12.3877 19.5363 12.8615C18.2756 13.1676 17.6774 14.6119 18.3524 15.7198C19.3973 17.4348 17.4348 19.3973 15.7198 18.3524C14.6119 17.6774 13.1676 18.2756 12.8615 19.5363C12.3877 21.4879 9.61225 21.4879 9.13848 19.5363C8.83242 18.2756 7.38806 17.6774 6.28021 18.3524C4.56523 19.3973 2.60266 17.4348 3.64761 15.7198C4.32264 14.6119 3.72437 13.1676 2.46368 12.8615C0.512108 12.3877 0.512107 9.61225 2.46368 9.13847C3.72437 8.83242 4.32264 7.38806 3.64761 6.28021C2.60266 4.56523 4.56523 2.60265 6.28021 3.64761C7.38806 4.32264 8.83242 3.72437 9.13848 2.46368Z",
    stroke: "#10A0B6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3333 11C14.3333 12.8409 12.8409 14.3333 11 14.3333C9.15905 14.3333 7.66667 12.8409 7.66667 11C7.66667 9.15905 9.15905 7.66667 11 7.66667C12.8409 7.66667 14.3333 9.15905 14.3333 11Z",
    stroke: "#10A0B6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/Settings.1ecfb21cf121c1a0391987355a988272.svg";
export { ForwardRef as ReactComponent };